import connectApi from "./apiCall";

// Common File For Api's

export const login = async (data) => {
  return await connectApi("adminLogin", data, "POST");
};

export const companyFind = async (data) => {
  return await connectApi("companyFind", data, "POST");
};
export const companyCreate = async (data) => {
  return await connectApi("companyCreate", data, "POST");
};
export const companyUpdate = async (data) => {
  return await connectApi("companyUpdate", data, "POST");
};
export const userFind = async (data) => {
  return await connectApi("userFind", data, "POST");
};
export const userCreate = async (data) => {
  return await connectApi("userCreate", data, "POST");
};
export const userUpdate = async (data) => {
  return await connectApi("userUpdate", data, "POST");
};
export const userSalaryCreate = async (data) => {
  return await connectApi("userSalaryCreate", data, "POST");
};

export const userToggleStatus = async (data) => {
  return await connectApi("userToggleStatus", data, "POST");
};
export const userDelete = async (data) => {
  return await connectApi("userDelete", data, "POST");
};

export const secondaryBillCreate = async (data) => {
  return await connectApi("secondaryBillCreate", data, "POST");
};
export const ledgerFind = async (data) => {
  return await connectApi("ledgerFind", data, "POST");
};
export const dashboardStats = async (data) => {
  return await connectApi("dashboardStats", data, "GET");
};

export const userLedgerFind = async (data) => {
  return await connectApi("userLedgerFind", data, "POST");
};
export const userLedgerFindExport = async (data) => {
  return await connectApi("userLedgerFindExport", data, "POST");
};
export const ledgerFindExport = async (data) => {
  return await connectApi("ledgerFindExport", data, "POST");
};
export const secondaryBillUpdate = async (data) => {
  return await connectApi("secondaryBillUpdate", data, "POST");
};
export const secondaryBillFind = async (data) => {
  return await connectApi("secondaryBillFind", data, "POST");
};
export const secondaryBillDelete = async (data) => {
  return await connectApi("secondaryBillDelete", data, "POST");
};
export const ledgerFindAll = async (data) => {
  return await connectApi("ledgerFindAll", data, "POST");
};
export const UserledgerFindAll = async (data) => {
  return await connectApi("UserledgerFindAll", data, "POST");
};

export const DeliveryChallanFind = async (data) => {
  return await connectApi("DeliveryChallanFind", data, "POST");
};
export const ConstructionledgerFind = async (data) => {
  return await connectApi("ConstructionledgerFind", data, "POST");
};

export const ConstructionledgerFindOne = async (data) => {
  return await connectApi("ConstructionledgerFindOne", data, "POST");
};
export const ConstructionledgerFindTwo = async (data) => {
  return await connectApi("ConstructionledgerFindTwo", data, "POST");
};


export const ledgerCreate = async (data) => {
  return await connectApi("ledgerCreate", data, "POST");
};
export const ledgerUpdate = async (data) => {
  return await connectApi("ledgerUpdate", data, "POST");
};
export const DeliveryChallanCreate = async (data) => {
  return await connectApi("DeliveryChallanCreate", data, "POST");
};
export const DeliveryChallanUpdate = async (data) => {
  return await connectApi("DeliveryChallanUpdate", data, "POST");
};
export const getLastDcNo = async (data) => {
  return await connectApi("getLastDcNo", data, "GET");
};
export const DeliveryChallanFindone = async (data) => {
  return await connectApi("DeliveryChallanFindone", data, "POST");
};
export const DeliveryChallanDelete = async (data) => {
  return await connectApi("DeliveryChallanDelete", data, "POST");
};
export const DcUploadBill = async (data) => {
  return await connectApi("DcUploadBill", data, "POST");
};




export const productTypeCreate = async (data) => {
  return await connectApi("productTypeCreate", data, "POST");
};
export const productTypeUpdate = async (data) => {
  return await connectApi("productTypeUpdate", data, "POST");
};
export const productTypeDelete = async (data) => {
  return await connectApi("productTypeDelete", data, "POST");
};
export const productTypeFind = async (data) => {
  return await connectApi("productTypeFind", data, "POST");
};






export const productTypeCreateOne = async (data) => {
  return await connectApi("productTypeCreateOne", data, "POST");
};
export const productTypeUpdateOne = async (data) => {
  return await connectApi("productTypeUpdateOne", data, "POST");
};
export const productTypeDeleteOne = async (data) => {
  return await connectApi("productTypeDeleteOne", data, "POST");
};
export const productTypeFindOne = async (data) => {
  return await connectApi("productTypeFindOne", data, "POST");
};




export const productTypeCreateTwo = async (data) => {
  return await connectApi("productTypeCreateTwo", data, "POST");
};
export const productTypeUpdateTwo = async (data) => {
  return await connectApi("productTypeUpdateTwo", data, "POST");
};
export const productTypeDeleteTwo = async (data) => {
  return await connectApi("productTypeDeleteTwo", data, "POST");
};
export const productTypeFindTwo = async (data) => {
  return await connectApi("productTypeFindTwo", data, "POST");
};



export const site_settingsfindAll = async (data) => {
  return await connectApi("site_settingsfindAll", data, "GET");
};
export const ConstructionledgerUpdate = async (data) => {
  return await connectApi("ConstructionledgerUpdate", data, "POST");
};

export const ConstructionledgerUpdateTwo = async (data) => {
  return await connectApi("ConstructionledgerUpdateTwo", data, "POST");
};
export const ConstructionledgerUpdateOne = async (data) => {
  return await connectApi("ConstructionledgerUpdateOne", data, "POST");
};

export const ConstructionledgerCreate = async (data) => {
  return await connectApi("ConstructionledgerCreate", data, "POST");
};

export const ConstructionledgerCreateOne = async (data) => {
  return await connectApi("ConstructionledgerCreateOne", data, "POST");
};
export const ConstructionledgerCreateTwo = async (data) => {
  return await connectApi("ConstructionledgerCreateTwo", data, "POST");
};


export const SubAdminFind = async (data) => {
  return await connectApi("SubAdminFind", data, "POST");
};
export const SubAdminCreate = async (data) => {
  return await connectApi("SubAdminCreate", data, "POST");
};
export const SubAdminUpdate = async (data) => {
  return await connectApi("SubAdminUpdate", data, "POST");
};
export const SubAdminDelete = async (data) => {
  return await connectApi("SubAdminDelete", data, "POST");
};
export const SubAdminStatusUpdate = async (data) => {
  return await connectApi("SubAdminStatusUpdate", data, "POST");
};
export const ConstructionledgerUploadBill = async (data) => {
  return await connectApi("ConstructionledgerUploadBill", data, "POST");
};
export const ConstructionledgerUploadBillOne = async (data) => {
  return await connectApi("ConstructionledgerUploadBillOne", data, "POST");
};
export const ConstructionledgerUploadBillTwo = async (data) => {
  return await connectApi("ConstructionledgerUploadBillTwo", data, "POST");
};
export const adminChangePassword = async (data) => {
  return await connectApi("adminChangePassword", data, "POST");
};
export const siteSettingupdate = async (data) => {
  return await connectApi("siteSettingupdate", data, "POST");
};


export const createLedgerEntry = async (data) => {
  return await connectApi("createLedgerEntry", data, "POST");
};
export const HyperXcreateLedgerEntry = async (data) => {
  return await connectApi("HyperXcreateLedgerEntry", data, "POST");
};
export const getLedgerEntries = async (data) => {
  return await connectApi("getLedgerEntries", data, "POST");
};
export const HyperXgetLedgerEntries = async (data) => {
  return await connectApi("HyperXgetLedgerEntries", data, "POST");
};

export const getLastBalance = async (data) => {
  return await connectApi("getLastBalance", data, "GET");
};
export const HyperXgetLastBalance = async (data) => {
  return await connectApi("HyperXgetLastBalance", data, "GET");
};

export const updateLedgerEntry = async (data) => {
  return await connectApi("updateLedgerEntry", data, "POST");
};
export const HyperXupdateLedgerEntry = async (data) => {
  return await connectApi("HyperXupdateLedgerEntry", data, "POST");
};
export const uploadBankStatement = async (data) => {
  return await connectApi("uploadBankStatement", data, "POST");
};
export const HyperXuploadBankStatement = async (data) => {
  return await connectApi("HyperXuploadBankStatement", data, "POST");
};

export const createCompanyStatement = async (data) => {
  return await connectApi("createCompanyStatement", data, "POST");
};
export const getCompanyStatement = async (data) => {
  return await connectApi("getCompanyStatement", data, "POST");
};


export const billFormatFind = async (data) => {
  return await connectApi("billFormatFind", data, "POST");
};
export const billFormatFindOne = async (data) => {
  return await connectApi("billFormatFindOne", data, "POST");
};
export const billFormatUpdate = async (data) => {
  return await connectApi("billFormatUpdate", data, "POST");
};
export const billFormatStatusUpdate = async (data) => {
  return await connectApi("billFormatStatusUpdate", data, "POST");
};
